const shouldRetry = (args, status) => {
    if (status >= 502 && status <= 504 && args.retriesTaken === undefined) {
        return true;
    }

    return args.retries !== undefined && args.retries > 0;
};

const fetch = global.fetch;

const fetchWithRetries = async (url, args = {}) => {
    try {
        const result = await fetch(url, args);

        if (!result.ok) {
            const error = new Error(`Error fetching url (${url}) with status code ${result.status}`);
            error.url = url;
            error.status = result.status;
            throw error;
        }

        return result;
    } catch (e) {
        if (shouldRetry(args, e.status)) {
            const newArgs = {
                ...args,
                retries: args.retries - 1,
                retriesTaken: (args.retriesTaken || 0) + 1,
            };
            return fetchWithRetries(url, newArgs);
        } else {
            throw e;
        }
    }
};

global.fetchWithRetries = fetchWithRetries;
